/*
  Virasat product page: when the shopper picks another size, Horizon fetches the page for that
  variant and fires "shopify:product:select". Any Virasat element marked [data-virasat-live]
  with an id is then swapped for its copy from the fetched HTML (the price line, for example).

  The phone sticky bar's quantity pill ([data-v-sticky-qty]) steps the main form's quantity
  selector and shows its value, so the bar and the form always add the same quantity.
*/
if (!window.virasatProductLive) {
  window.virasatProductLive = true;

  const mainQuantityInput = (scope) =>
    scope.querySelector('product-form-component quantity-selector-component input[ref="quantityInput"]');

  const syncStickyQuantity = (scope) => {
    const input = mainQuantityInput(scope);
    if (!input) return;
    scope.querySelectorAll('[data-v-sticky-qty-value]').forEach((element) => {
      element.textContent = input.value;
    });
  };

  document.addEventListener('shopify:product:select', async (event) => {
    const source = event.target instanceof Element ? event.target : null;
    if (!source || source.closest('product-card')) return;

    const scope = source.closest('.shopify-section, dialog') || document;

    try {
      const { detail } = await event.promise;
      const html = detail?.html;
      if (!html) return;

      scope.querySelectorAll('[data-virasat-live][id]').forEach((element) => {
        const fresh = html.querySelector(`#${CSS.escape(element.id)}`);
        if (fresh) element.innerHTML = fresh.innerHTML;
      });

      // Horizon re-renders the sticky bar for the new variant; show the form's quantity again after it
      setTimeout(() => syncStickyQuantity(scope));
    } catch (error) {
      // Leave the current values in place if the variant could not be loaded
    }
  });

  document.addEventListener('click', (event) => {
    const step = event.target instanceof Element ? event.target.closest('[data-v-sticky-qty] [data-step]') : null;
    if (!step) return;

    const section = step.closest('.shopify-section');
    const selector = section?.querySelector('product-form-component quantity-selector-component');
    const button = step instanceof HTMLElement && step.dataset.step === 'minus' ? 'minusButton' : 'plusButton';
    selector?.querySelector(`[ref="${button}"]`)?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  });

  document.addEventListener('quantity-selector:update', (event) => {
    if (!(event.target instanceof Element) || event.detail?.cartLine) return;
    if (!event.target.closest('product-form-component')) return;
    event.target
      .closest('.shopify-section')
      ?.querySelectorAll('[data-v-sticky-qty-value]')
      .forEach((element) => {
        element.textContent = String(event.detail.quantity);
      });
  });

  document.querySelectorAll('sticky-add-to-cart').forEach((sticky) => {
    const section = sticky.closest('.shopify-section');
    if (section) syncStickyQuantity(section);
  });
}
